var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 120,
    viewBox: "0 0 150 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45,75) rotate(-15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    stroke: "#333",
    strokeWidth: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -38,
    x2: 0,
    y2: -28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 28,
    x2: 0,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    x1: -38,
    y1: 0,
    x2: -28,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 0,
    x2: 38,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: -27,
    y1: -27,
    x2: -18,
    y2: -18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 27,
    x2: 18,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: -27,
    y1: 27,
    x2: -18,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: -27,
    x2: 18,
    y2: -18
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 12,
    fill: "#333"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,45) rotate(20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    stroke: "#333",
    strokeWidth: 6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -26,
    x2: 0,
    y2: -18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 18,
    x2: 0,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    x1: -26,
    y1: 0,
    x2: -18,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 0,
    x2: 26,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18,
    y1: -18,
    x2: -12,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18,
    y1: 18,
    x2: -12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: -18,
    x2: 12,
    y2: -12
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.80e81ec4a550b2d8f6dbe2aecbf7585f.svg";
export { ForwardRef as ReactComponent };